import { render, staticRenderFns } from "./Tastes.vue?vue&type=template&id=28e21393&"
import script from "./Tastes.vue?vue&type=script&lang=js&"
export * from "./Tastes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports